import { render, staticRenderFns } from "./CustomSearchErgoEval.vue?vue&type=template&id=563d23c7"
import script from "./CustomSearchErgoEval.vue?vue&type=script&lang=js"
export * from "./CustomSearchErgoEval.vue?vue&type=script&lang=js"
import style0 from "./CustomSearchErgoEval.vue?vue&type=style&index=0&id=563d23c7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports